"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var stringMatching = function stringMatching(regex) {
  if (!(regex instanceof RegExp)) throw new Error('Must provide a regular expression for a regex validator');
  return function (props, propName) {
    var str = props[propName];

    if (!regex.test(str)) {
      return new Error("Expected prop `".concat(propName, "` to match `").concat(regex.toString(), "` but got `").concat(str, "`"));
    }

    return true;
  };
};

var _default = stringMatching;
exports.default = _default;